import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useAuth, useLanguage } from '../../App';
import { Button } from '../../components/ui/button';
import { Seo } from '../../components/seo/Seo';
import { NOT_FOUND } from '../../seo/publicContent';
import { pagePath, LANGS } from '../../seo/seoConfig.mjs';

/** Soft-404 page: never indexed, links back to the public home and the app. */
export default function NotFoundPage() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const lang = LANGS.includes(language) ? language : 'fr';
  const copy = NOT_FOUND[lang];
  const appHref = user ? (user.onboarding_complete ? '/dashboard' : '/onboarding') : '/auth';

  return (
    <div className="min-h-screen bg-[var(--lux-ink)] flex items-center justify-center px-6" data-testid="not-found-page">
      <Seo title={copy.seoTitle} description={copy.text} robots="noindex, nofollow" lang={lang} />
      <div className="max-w-md w-full text-center space-y-6 fade-in">
        <span className="mx-auto w-14 h-14 rounded-2xl bg-lux-gold/10 text-[var(--lux-gold)] flex items-center justify-center"><Compass className="w-7 h-7" /></span>
        <p className="font-display text-7xl text-white/10 tabular-nums">404</p>
        <h1 className="font-display text-3xl text-white">{copy.title}</h1>
        <p className="text-white/55">{copy.text}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button asChild className="h-11 bg-[var(--lux-gold)] text-[var(--lux-ink)] hover:bg-[var(--lux-gold-2)] font-semibold" data-testid="not-found-home-link">
            <Link to={pagePath('home', lang)}>{copy.home}</Link>
          </Button>
          <Button asChild variant="outline" className="h-11 bg-[var(--lux-panel)] border-white/10 text-white hover:bg-[var(--lux-panel-2)]" data-testid="not-found-app-link">
            <Link to={appHref}>{copy.app}</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
